export const HIGHLIGHT_CLASS = "devtools-xray-highlight";
export const HIGHLIGHTS_ENABLED = "devtools-xray-highlight-enabled";
export const FILTER_KEY = "devtools-xray-filter";
export const EXCLUDE_KEY = "devtools-xray-exclude";
export const BANNER_KEY = "devtools-xray-banner";
export const DS_COMPONENT_PREFIX = "DS.";
